import { EJsonQueryPriceType } from '../../../../../json_query';

import { CoworkingPriceTypeDropdownModel } from '../models/CoworkingPriceTypeDropdownModel';
import { CoworkingPriceTypeDropdownCollectionModel } from '../models/CoworkingPriceTypeDropdownCollectionModel';

export const coworkingSwitchButtonsMapper = new CoworkingPriceTypeDropdownCollectionModel(
  new CoworkingPriceTypeDropdownModel('за всё', EJsonQueryPriceType.All),
  new CoworkingPriceTypeDropdownModel('за раб. место', EJsonQueryPriceType.Workplace),
).collection;
